<template>
  <div :style="{direction:$t('direction')}" class="site-wrapper">

    <Header></Header>
    
    <div class="real-time">
      <div class="real-time-inner">
        
        <div class="p-4"> <i class="fa fa-exclamation text-danger"></i> توجه: قیمت های درج شده در این وبسایت بدون در نظر گرفتن فی شبکه و کارمزد تبدیل می باشد.</div>

        <div class="ar-form-group px-2">
          <input type="text" v-model="crypto_search" class="ar-form-control" placeholder="جست و جو بر اساس نماد">
        </div>

        <div class="table-responsive">
          <table class="table ar-table">
            <thead>
              <tr>
                <th>#</th>
                <th class="text-right">رمز ارز</th>
                <th>قیمت خرید</th>
                <th>قیمت فروش</th>
                <th>قیمت جهانی</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item , key) in crypto_list" :key="key">
                <template v-if="item.symbol.endsWith('USDT')">
                  <template v-if="item.symbol.includes(crypto_search)">
                    <template v-if="
                      !item.symbol.endsWith('BULLUSDT') && 
                      !item.symbol.endsWith('BEARUSDT') && 
                      !item.symbol.endsWith('UPUSDT') && 
                      !item.symbol.endsWith('DOWNUSDT')">

                      <td>{{ key + 1 }}</td>
                      <td>
                        
                        <div class="box-item">
                          <div class="img-box"><img :src="StaticImageUrl+'assets/images/icon/'+ item.symbol +'.png'"></div>
                          <div class="coin-txt-box">
                              <p class="prsIcon">{{crypto_currencies[item.symbol]}}</p>
                              <p class="engIcon">
                                <template v-if="item.symbol">
                                  {{ item.symbol.replace('USDT' , '') }}
                                </template>
                              </p>
                          </div>
                        </div>
                        
                      </td>
                      <td>{{formatPrice(Math.round(parseFloat(item.markPrice) * state_prices.buy_price))}} تومان</td>
                      <td>{{formatPrice(Math.round(parseFloat(item.markPrice) * state_prices.sale_price))}} تومان</td>
                      <th><bdi>$
                        <template v-if="item.markPrice > 100">{{ parseFloat(item.markPrice).toFixed(2) }}</template>
                        <template v-else-if="item.markPrice > 10">{{ parseFloat(item.markPrice).toFixed(3) }}</template>
                        <template v-else-if="item.markPrice > 1">{{ parseFloat(item.markPrice).toFixed(4) }}</template>
                        <template v-else-if="item.markPrice > 0.1">{{ parseFloat(item.markPrice).toFixed(5) }}</template>
                        <template v-else>{{ parseFloat(item.markPrice).toFixed(6) }}</template>
                      </bdi></th>

                    </template>
                  </template>
                </template>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="loading" class="py-5 text-center text-primary-dark">
          در حال بارگذاری اطلاعات ...
        </div>
              
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header'
import Footer from './Footer'
import {io} from 'socket.io-client';
import crypto_currencies from '../plugins/crypto_currencies'
export default {
  name: 'RealTimePrice',
  components:{
    Header,
    Footer
  },
  data(){
    return{
      prices:{},
      data:{},
      connection:null,
      crypto_search:'',
      crypto_list:{},
      search:'',
      crypto_currencies,
      loading : true,
      socket : null,
    }
  },
  watch:{
    crypto_search:function() {
      this.crypto_search = this.crypto_search.toUpperCase()
    }
  },
  computed:{
    filterSearch() {
      if(this.crypto_search == ''){
        return this.crypto_list
      }else{
        return this.crypto_list.filter( item => {
          if(item.prs){
            const word = this.crypto_search.toUpperCase()
            return item.prs.includes(this.crypto_search) || item.nikeName.includes(word)
          }
        })
      }
    }
  },
  methods:{
    getRealTimePrice (){
      this.$axios.get(`getRealTimePrice?search=${this.search}`)
      .then(res => {
        this.data = res.data.data
      })
      .catch(err => {
      });
    },
    getPrices () {      
      this.$axios.get(`getPrices`)
      .then(res => {
        this.prices = res.data.data
      })
      .catch(err => {
      });

    },
  },
  created() {
    const vm = this
    vm.socket = io(vm.socketUrl);
    vm.socket.emit('live_crypto_list');
    
    vm.socket.on('live_crypto_list', (data) => {
      vm.crypto_list = data
      this.loading = false
    });

  },
  mounted() {
    this.activeLoading(false)
    let vm = this
    this.getPrices()
  },
  beforeMount() {
    window.scrollTo(0, 0);
  }
}
</script>
